// « Ça ressemble à des maths / de l'histoire / de la SVT / du français » :
// l'article partitif dépend du nombre, du genre et de l'initiale de la
// matière — « du Maths » n'est pas du français. Les règles se lisent sur le
// premier mot du nom, ce qui couvre les intitulés composés du catalogue
// (« Physique-Chimie », « Sciences de l'ingénieur », « Langues, Littératures… »).

const PLURAL_FIRST_WORDS = new Set([
    "maths",
    "sciences",
    "arts",
    "humanités",
    "langues",
    "biotechnologies",
    "ses",
])

const FEMININE_FIRST_WORDS = new Set([
    "physique",
    "chimie",
    "svt",
    "philosophie",
    "technologie",
    "snt",
    "biochimie",
    "biologie",
    "santé",
    "géographie",
])

// Pas de matière en h aspiré au catalogue : un h initial élide comme une voyelle.
const ELIDING_INITIAL = /^[aàâeéèêëiîïoôuùûüyh]/

const isAcronym = (name) => name.length <= 4 && name === name.toUpperCase()

/**
 * Le nom de la matière précédé de son article partitif, pour une phrase :
 * « des maths », « de l'anglais », « de la SVT », « du français ».
 * Les sigles gardent leur casse, le reste passe en minuscules comme en prose.
 */
export const subjectWithPartitive = (subjectName) => {
    const name = subjectName.trim()
    const display = isAcronym(name) ? name : name.toLowerCase()
    const firstWord = name.toLowerCase().split(/[\s\-,:]+/)[0]

    if (PLURAL_FIRST_WORDS.has(firstWord)) return `des ${display}`
    if (ELIDING_INITIAL.test(firstWord)) return `de l'${display}`
    if (FEMININE_FIRST_WORDS.has(firstWord)) return `de la ${display}`
    return `du ${display}`
}
